import type { FaireProductEntity } from "../../entity_types/product";

export const p_yuemb9tsbp: FaireProductEntity = {
  token: "p_yuemb9tsbp",
  type: "product",
  name: "Gold Vintage Illustrated Alphabet Art Print",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/80b35056c36e9b0944d05a9e610b6034053e4f623222b190d114ec022b15d445.webp",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/11a39034a61bb66fc5bf3e849f4861376023cddb7c4aca1913175a52b7e8fa80.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
